import { FC, memo } from 'react'

import { FormInputProps } from 'brief-form'
import { Request } from 'commons/utils/request'

import { ChoiceOption } from '../../types'
import { ColumnMultiSelect } from './ColumnMultiSelect'

export type CompanyMultiSelectProps = FormInputProps<
  number[] | null | unknown,
  {
    filters?: {
      field: string
      type: string
      value: string | number | boolean
    }[]
    portal: 'bank' | 'client'
    data?: ChoiceOption[]
    'data-qa'?: string
  }
>

export const CompanyMultiSelect: FC<CompanyMultiSelectProps> = memo((props) => {
  const { value, onChange, data, portal, filters, ...rest } = {
    ...props
  }

  return (
    <ColumnMultiSelect
      {...rest}
      value={value}
      onChange={onChange}
      placeholder="Add Company"
      searchable={true}
      data={data}
      serverOptions={
        portal === 'bank'
          ? {
              filters,
              url: Request.urls.bank.companySearch,
              requestSearchString: 'searchString',
              limit: 10,
              mapper: (item) => ({ label: item.companyName, value: item.id })
            }
          : undefined
      }
    />
  )
})
